import React from 'react';
import IconsCategories from './IconsCategories';

const Categories = (props) => {
    const { locale, incidentsCategories, onChangeQualification, categorySelected } = props;

    return (
        <div className='col-6'>
            {
                incidentsCategories.map((category, index) => (
                    <div key={index} className='row'>
                        <div className={`col-12 ${category === categorySelected ? 'alert alert-success' : ''}`}>
                            <IconsCategories locale={locale} icon={category} onChangeQualification={onChangeQualification} />
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default Categories;
